// extracted by mini-css-extract-plugin
export default {"menuBlock":"_H-z","title":"aI-z","nav":"bI-z","flexCell":"cI-z","facetLink":"dI-z"};